const rail = {
  rails: "Sporen", // translated
  senior: "Senior", // translated
  seniors: "Senioren", // translated
  youths: "Jongeren", // translated
  yearOld: "jaar oud", // translated
  yearsOld: "jaar oud", // translated
};

export default rail;
